// src/features/eventos/components/EventoCard.js
import React from "react";
import { IoPeopleOutline, IoCalendarOutline, IoTrashOutline, IoPencil } from "react-icons/io5";
import styles from "../styles/eventos.module.css";
import { toSpanishDate } from "../domain/eventosListUtils";

export function EventoCard({
    evento,
    onVer,
    onEditar,
    onDuplicar,
    onEliminar,
}) {
    return (
        <div
            className={styles["evento-card"]}
            role="button"
            tabIndex={0}
            onClick={() => onVer(evento.id)}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") onVer(evento.id);
            }}
        >
            <div className={styles["evento-header"]}>
                <div>
                    <h2>
                        {evento.nombre}{" "}
                        {evento.esProvisional && (
                            <span className={`${styles.badge} ${styles["badge-provisional"]}`}>
                                Provisional
                            </span>
                        )}
                    </h2>

                    <p className={styles["evento-fechas"]}>
                        <IoCalendarOutline /> {toSpanishDate(evento.fechaInicio)} - {toSpanishDate(evento.fechaFin)}
                    </p>
                </div>

                <div className={styles["evento-info"]}>
                    <span>
                        <IoPeopleOutline /> {evento.participaciones?.length || 0} personas
                    </span>

                    <div className={styles["evento-actions"]}>
                        <button
                            type="button"
                            className={`${styles["btn-action"]} ${styles["btn-edit"]}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                onVer(evento.id);
                            }}
                        >
                            Ver
                        </button>

                        <button
                            type="button"
                            className={`${styles["btn-action"]} ${styles["btn-edit"]}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                onEditar(evento);
                            }}
                        >
                            <IoPencil size={16} /> Editar
                        </button>

                        <button
                            type="button"
                            className={`${styles["btn-action"]} ${styles["btn-edit"]}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                onDuplicar(evento);
                            }}
                        >
                            Duplicar
                        </button>

                        <button
                            type="button"
                            className={`${styles["btn-action"]} ${styles["btn-delete"]}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                onEliminar(evento);
                            }}
                        >
                            <IoTrashOutline size={16} /> Eliminar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
